document.addEventListener('DOMContentLoaded', () => {
  console.log('3DGC Product Reviews: Initializing...');
  const container = document.getElementById('product-reviews-container');
  if (!container) return;

  const config = window.product_reviews || {};
  const { prefix, productId, language, limit, strings } = config;

  let query = [];
  if (productId) {
    query.push(`p=${productId}`);
  } else if (limit) {
    query.push(`c=${limit}`);
  } else {
    query.push(`c=8`);
  }

  if (language) {
    query.push(`l=${language}`);
  }

  const avatarColors = [
    '#A3AA86', '#8F9674', '#D7C38A', '#A9A17E',
    '#9CB9B2', '#A7A9C2', '#D9BE78', '#C96657'
  ];

  function getAvatarInitials(name) {
    const initials = name.match(/\b\w/g) || [];
    return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
  }

  function getAvatarColor(index) {
    return avatarColors[index % avatarColors.length];
  }

  function formatDate(dateStr) {
    const date = new Date(dateStr);
    return date.toLocaleDateString();
  }

  function renderStars(rating) {
    let starsHtml = '';
    for (let i = 1; i <= 5; i++) {
      starsHtml += `
        <svg width="26px" height="26px" viewBox="1 1 22 22">
          <path fill="${rating >= i ? 'black' : '#e8e8e8'}"
                d="M12 3c-.3 0-.6.2-.7.4l-2 4.5-5 .5c-.3 0-.6.2-.7.5s0 .6.2.8l3.6 3.5-.9 4.7c0 .3.1.6.3.7.2.2.4.2.6.2s.4-.1.6-.3l4.1-2.6 4.1 2.6c.2.1.4.2.6.2s.5 0 .6-.2c.2-.1.3-.4.3-.7l-.9-4.7 3.6-3.5c.2-.2.3-.5.2-.8s-.4-.5-.7-.5l-5-.5-2-4.5c-.1-.3-.4-.4-.7-.4z"/>
        </svg>`;
    }
    return starsHtml;
  }

  function renderCard(review, index) {
    const isTranslated = review.isTranslated;
    const langKey = review.language;
    const translatedFrom = strings.translated_from || 'Translated from';
    const langName = strings[langKey] || langKey;
    const showOriginal = strings.show_original || 'Show original';
    const showTranslated = strings.show_translated || 'Show translated';

    return `
      <div class="product-review-card" data-index="${index}">
        <div class="product-review-card__rating">
          ${renderStars(review.rating)}
        </div>
        <div class="product-review-card__header">
          <div class="product-review-card__avatar" style="background-color: ${getAvatarColor(index)}">
            ${getAvatarInitials(review.name)}
          </div>
          <div class="product-review-card__title">
            <div class="product-review-card__name">${review.name}</div>
            <div class="product-review-card__date">${formatDate(review.date)}</div>
          </div>
        </div>
        <div class="product-review-card__text" data-original="${review.originalText || ''}" data-translated="${review.text || ''}">
          ${review.text}
        </div>
        ${isTranslated ? `
          <div class="product-review-card__translated-info">
            <span class="translated-label">${translatedFrom} ${langName}.</span>
            <span class="product-review-card__toggle" data-state="translated">${showOriginal}</span>
          </div>
        ` : ''}
      </div>
    `;
  }

  // Artificial delay to ensure skeleton is visible
  setTimeout(() => {
    fetch(`${prefix}/reviews.json?${query.join('&')}`)
      .then(response => response.json())
      .then(data => {
        if (!data || data.length === 0) {
          container.innerHTML = `
            <div class="product-reviews__no-reviews">
              ${strings.no_reviews || 'This product has not been reviewed yet.'}
            </div>
          `;
          return;
        }

        // Column distribution logic
        let columnCount = 4;
        if (window.innerWidth < 750) columnCount = 1;
        else if (window.innerWidth < 990) columnCount = 2;
        else if (window.innerWidth < 1250) columnCount = 3;

        const columns = Array.from({ length: columnCount }, () => []);
        const basePerColumn = Math.floor(data.length / columnCount);
        const remainder = data.length % columnCount;

        let currentIndex = 0;
        for (let i = 0; i < columnCount; i++) {
          const count = basePerColumn + (i < remainder ? 1 : 0);
          columns[i] = data.slice(currentIndex, currentIndex + count);
          currentIndex += count;
        }

        const columnsHtml = columns.map(column => `
          <div class="product-reviews__column">
            ${column.map((review, idx) => renderCard(review, data.indexOf(review))).join('')}
          </div>
        `).join('');

        container.innerHTML = `
          <div class="product-reviews__columns">
            ${columnsHtml}
          </div>
        `;

        // Add event listeners for toggle
        container.querySelectorAll('.product-review-card__toggle').forEach(toggle => {
          toggle.addEventListener('click', (e) => {
            const btn = e.target;
            const card = btn.closest('.product-review-card');
            const textEl = card.querySelector('.product-review-card__text');
            const isTranslatedState = btn.dataset.state === 'translated';

            if (isTranslatedState) {
              textEl.innerHTML = textEl.dataset.original;
              btn.textContent = strings.show_translated || 'Show translated';
              btn.dataset.state = 'original';
            } else {
              textEl.innerHTML = textEl.dataset.translated;
              btn.textContent = strings.show_original || 'Show original';
              btn.dataset.state = 'translated';
            }
          });
        });
      })
      .catch(err => {
        console.error('Failed to fetch reviews:', err);
        container.innerHTML = `
          <div class="product-reviews__no-reviews">
            ${strings.no_reviews || 'This product has not been reviewed yet.'}
          </div>
        `;
      });
  }, 1000);
});
